import { useMemo } from "react";
import { useSelector } from "react-redux";

import { resolveSubtreeMultilingualNodesCreate } from "../nodes/querying/index.ts";
import { getManifestSelector, getNodeMultilingualPropertiesSelector } from "../state/index.ts";
import type { DesignerNode } from "../types/index.ts";

export const useVariantSubtree = (node: DesignerNode | null) => {
  const getNodeMultilingualProperties = useSelector(getNodeMultilingualPropertiesSelector);
  const getManifest = useSelector(getManifestSelector);

  return useMemo(
    () => (node ? resolveSubtreeMultilingualNodesCreate({ getManifest, getNodeMultilingualProperties })(node) : []),
    [getManifest, getNodeMultilingualProperties, node],
  );
};
